import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { CloseCircleIcon, DownloadSlimIcon } from "../../../common/icons";
import { defineMessages, injectIntl } from "react-intl";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    minHeight: "66px",
    padding: "12px 16px",
    backgroundColor: "var(--system-error-bg)",
    borderRadius: "8px",
    marginTop: "10px",
    marginBottom: "30px",
    boxSizing: "border-box",
    gap: "16px",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  messageGroup: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  closeIcon: {
    width: "32px",
    height: "32px",
    minWidth: "32px",
    fill: "var(--system-error-bg) !important",
    color: "var(--system-error) !important",

    "& path, & circle, & g": {
      stroke: "var(--system-error) !important",
      fill: "var(--system-error-bg) !important",
    },
  },
  textContent: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    gap: "2px",
  },
  title: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
    color: "var(--text-primary, #000) !important",
    margin: "0 !important",
    lineHeight: "1.2 !important",
    fontFamily: "inherit",
  },
  description: {
    fontSize: "12px !important",
    fontWeight: "400 !important",
    color: "var(--text-secondary, #333) !important",
    margin: "0 !important",
    lineHeight: "1.4 !important",
  },
  button: {
    "--icon-color": "var(--system-error)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "transparent",
    border: "2px solid var(--system-error)",
    color: "var(--system-error)",
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    whiteSpace: "nowrap",
    outline: "none",

    "& svg": {
      width: "20px",
      height: "20px",
      minWidth: "20px",
      display: "block",
      fill: "none !important",
    },

    "&:hover": {
      backgroundColor: "var(--system-error)",
      color: "#ffffff",
      "--icon-color": "#ffffff",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },
};

const messages = defineMessages({
  plateError: {
    id: "vehicle.single.registry.upload.upload.resume.errors.plate",
    defaultMessage: "plate error",
  },
  platesError: {
    id: "vehicle.single.registry.upload.upload.resume.errors.plates",
    defaultMessage: "plates with error",
  },
  templateError: {
    id: "vehicle.single.registry.upload.upload.resume.errors.template",
    defaultMessage: "Correct fill patterns are in our official template.",
  },
  downloadTemplate: {
    id: "vehicle.single.registry.upload.upload.resume.errors.download.template",
    defaultMessage: "Download template",
  },
});

class UploadFileResumeErrorsBase extends React.Component {
  render() {
    const { classes, count = 0, onDownloadClick, intl } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.messageGroup}>
          <CloseCircleIcon
            className={classes.closeIcon}
            stroke="var(--system-error)"
            fill="var(--system-error-bg)"
          />
          <div className={classes.textContent}>
            <p className={classes.title}>
              {count === 1
                ? `${count} ${intl.formatMessage(messages.plateError)}`
                : `${count} ${intl.formatMessage(messages.platesError)}`}
            </p>
            <p className={classes.description}>
              {intl.formatMessage(messages.templateError)}
            </p>
          </div>
        </div>
        <div>
          <button
            type="button"
            className={classes.button}
            onClick={onDownloadClick}
          >
            {intl.formatMessage(messages.downloadTemplate)}
            <DownloadSlimIcon stroke="var(--icon-color)" />
          </button>
        </div>
      </div>
    );
  }
}

export const UploadFileResumeErrors = withStyles(styles)(
  injectIntl(UploadFileResumeErrorsBase),
);
